import { inmunetApi } from '../../../api';

export const getConsulta = async() => {

    try {

        const { data } = await inmunetApi.get('/configuracionExpedienteClinico/consulta');

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data.consulta;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};